import React from 'react';

export default () => (
  <div className="c-heading c-heading--small u-mt">
    To add a staff member please click the Add Staff button in the top right corner.
  </div>
);
